import { PROFILE_AVATAR } from '@/views/participants/participantMockData';
import { getScreenerDraft } from './screenerDraftStore';
import { QUALIFY_METHODS, MOCK_OPT_IN_FORMS } from './optInFormMockData';

export { QUALIFY_METHODS, MOCK_OPT_IN_FORMS };

export const RESPONSE_STATUSES = {
  qualified: {
    label: 'Qualified',
    value: 'qualified',
    variant: 'completed',
    showChevron: false,
    clickable: false,
    color: '#33B273',
    background: '#F0FFF4',
  },
  pending: {
    label: 'Pending',
    value: 'pending',
    variant: 'responded',
    showChevron: false,
    clickable: false,
    color: '#B7791F',
    background: '#FFF3DC',
  },
  disqualified: {
    label: 'Disqualified',
    value: 'disqualified',
    variant: 'invited',
    showChevron: false,
    clickable: false,
    color: '#C53030',
    background: '#FED7D7',
  },
};

const DEFAULT_VIEW_QUESTIONS = [
  {
    id: 'q1',
    number: 1,
    type: 'single_choice',
    typeLabel: 'Single Choice',
    text: 'Are you currently looking to buy a home?',
    options: [
      { id: 'o1', label: 'Yes', selected: false },
      { id: 'o2', label: 'No', selected: false },
    ],
  },
  {
    id: 'q2',
    number: 2,
    type: 'multiple_choice',
    typeLabel: 'Multiple Choice',
    text: 'Which features matter most to you?',
    options: [
      { id: 'o1', label: 'Option 1', selected: false },
      { id: 'o2', label: 'Option 2', selected: false },
      { id: 'o3', label: 'Option 3', selected: false },
      { id: 'o4', label: 'Option 4', selected: false },
    ],
  },
  {
    id: 'q3',
    number: 3,
    type: 'text',
    typeLabel: 'Text',
    text: 'Tell us a bit about your current setup.',
    answer: '',
  },
  {
    id: 'q4',
    number: 4,
    type: 'single_choice',
    typeLabel: 'Single Choice',
    text: 'How soon are you looking to get started?',
    options: [
      { id: 'o1', label: 'Immediately', selected: false },
      { id: 'o2', label: 'Within a month', selected: false },
    ],
  },
  {
    id: 'q5',
    number: 5,
    type: 'single_choice',
    typeLabel: 'Single Choice',
    text: 'Would you be open to a follow-up interview?',
    options: [
      { id: 'o1', label: 'Yes', selected: false },
      { id: 'o2', label: 'No', selected: false },
    ],
  },
];

function mapDraftQuestions(questions = []) {
  return questions.map((question, index) => {
    const number = index + 1;
    if (question.type === 'text') {
      return {
        id: question.id,
        number,
        type: 'text',
        typeLabel: 'Text',
        text: question.prompt || 'Untitled question',
        answer: '',
      };
    }

    const typeLabel =
      question.type === 'multiple_choice' ? 'Multiple Choice' : 'Single Choice';

    return {
      id: question.id,
      number,
      type: question.type,
      typeLabel,
      text: question.prompt || 'Untitled question',
      options: (question.options || []).map((option, optionIndex) => ({
        id: option.id,
        label: option.label || `Option ${optionIndex + 1}`,
        selected: false,
      })),
    };
  });
}

export function getPublishedScreener(screenerId, query = {}) {
  const draft = getScreenerDraft(screenerId);
  if (draft) {
    return {
      id: draft.id,
      name: draft.name,
      qualifyMethod: draft.qualifyMethod,
      projectName: draft.projectName || 'Onboarding Study',
      created: 'Jun 12, 2026',
      lastEdited: '2 days ago',
      questions: mapDraftQuestions(draft.questions),
    };
  }

  const listItem = MOCK_OPT_IN_FORMS.find((form) => form.id === screenerId);
  return {
    id: screenerId || '1',
    name: query.name || listItem?.name || 'ABC Fit Screener',
    qualifyMethod:
      query.method || listItem?.qualifyMethod?.value || 'manual',
    projectName: listItem?.project?.name || 'Onboarding Study',
    created: 'Jun 12, 2026',
    lastEdited: '2 days ago',
    questions: DEFAULT_VIEW_QUESTIONS,
  };
}

function createResponseRow(id, statusKey) {
  return {
    id: String(id),
    participant: {
      name: 'Kritika Oberoi',
      email: 'kritikaoberoi@gmail.com',
      avatar: PROFILE_AVATAR,
    },
    email: 'kritikaoberoi@gmail.com',
    status: RESPONSE_STATUSES[statusKey],
    submitted: 'June 12, 2026',
    responseTitle: 'ABC Fit Screener',
    date: '23 Dec 2024',
    projectName: 'Onboarding Study',
  };
}

const STATUS_CYCLE = ['qualified', 'pending', 'disqualified'];

export function getScreenerResponses(screenerId) {
  // Keep empty for unpublished drafts so empty state can be tested when needed.
  const draft = getScreenerDraft(screenerId);
  if (draft && (!draft.questions || draft.questions.length === 0)) {
    return [];
  }

  return Array.from({ length: 11 }, (_, index) =>
    createResponseRow(index + 1, STATUS_CYCLE[index % STATUS_CYCLE.length]),
  );
}
